import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import style from "./account.module.scss";

const Card = ({ name, route, iconname }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (route) {
      navigate(route);
    }
  };
  return (
    <div
      className={style.card}
      onClick={handleCardClick}
      role="button"
      aria-label={`Navigate to ${name} page`}
    >
      <div className={style.iconContainer}>
        <i className={`tg-icons-${iconname}`}></i>
      </div>
      <span className={style.cardTitle}>{name}</span>
    </div>
  );
};

Card.propTypes = {
  name: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  iconname: PropTypes.string.isRequired,
};

export default Card;
